<template>
  <div class="container">
    <!-- <div class="banner">
      <div class="text-filter flex align-center justify-between">
        <img
          src="../../assets/images/fabricHall/search-icon.png"
          style="width: 28px; height: 28px; margin-left: 20px"
        />
        <input
          placeholder="请输入关键词进行搜索"
          class="search-input"
          v-model="query.keyword"
          @keyup.enter="onSearch"
        />
        <button class="search-submit" @click="onSearch">搜索</button>
      </div>
    </div> -->
    <div class="bread-nav-box">
      <div class="bread-nav">
        <b class="stick"></b>
        <span class="bread-nav-title">{{ type === 'fabric' ? '面料库' : '辅料库' }}</span>
        <span class="bread-nav-info">/ 汇聚优质面辅料，赋能服装全链路</span>
      </div>
      <div class="text-filter flex align-center justify-between">
        <img
          src="../../assets/images/fabricHall/search-icon.png"
          style="width: 28px; height: 28px; margin-left: 20px"
        />
        <input
          placeholder="请输入关键词进行搜索"
          class="search-input"
          v-model="query.keyword"
          @keyup.enter="onSearch"
        />
        <button class="search-submit" @click="onSearch">搜索</button>
      </div>
    </div>

    <div class="category-list">
      <div class="label-box">
        <div
          class="label-list flex">
          <div class="label-title">分类：</div>
          <CollapseText>
            <div class="label-items flex" >
              <div class="label-item" @click="choose_category(0, '全部')" :class="{ active: category_id == 0 }" >全部</div>
              <div class="label-item" v-if="type=='fabric'" @click="choose_category(v.fabric_category_id, v.category_name)" :class="{ active: category_id == v.fabric_category_id }" v-for="(v, kk) in category_list" :key="kk">{{ v.category_name }}</div>
              <div class="label-item"  v-if="type=='accessory'" @click="choose_category(v.accessory_category_id, v.category_name)" :class="{ active: category_id == v.accessory_category_id }" v-for="(v, kk) in category_list" :key="kk">{{ v.category_name }}</div>
            </div>
          </CollapseText>
        </div>
        <div
          class="label-list flex" v-if="type=='fabric'">
          <div class="label-title">类型：</div>
          <CollapseText>
            <div class="label-items flex">
              <div class="label-item"  @click="choose_type(1)" :class="{ active: query.type == 1 }">面料</div>
              <div class="label-item"  @click="choose_type(2)" :class="{ active: query.type == 2 }">里料</div>
            </div>
          </CollapseText>
        </div>
        <div
          class="label-list flex">
          <div class="label-title">上市：</div>
          <CollapseText>
            <div class="label-items flex">
              <div class="label-item"  @click="choose_publish_time(v)" :class="{ active: publish_time_selected.includes(v.value) }" v-for="(v, kk) in publish_time_list" :key="kk">{{ v.name }}</div>
            </div>
          </CollapseText>
        </div>
        <!-- <div
          class="label-list flex"
          v-for="(item, index) in label_list"
          :key="index"
        >
          <div class="label-title">{{ item.label_name }}：</div>
          <CollapseText>
            <div class="label-items flex">
              <div class="label-item" @click="choose_label(v)" :class="{ active: query.label_id.includes(v.id) }" v-for="(v, vv) in item.content" :key="vv">{{ v.name }}</div>
            </div>
          </CollapseText>
        </div> -->
        <div class="label-list flex">
          <div class="label-title">高级筛选：</div>
          <div class="label-items flex">
            <div class="label-item" v-for="(item, index) in label_list" :key="index">
              <FloatSelect 
                v-model="higherQuery[item.label_name]" 
                :options="item.content" 
                name-key="name" 
                value-key="id"
                :placeholder="item.label_name"
            />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="selectedTags.length" class="filter-result-box">
      <div class="filter-result">
        <TagsList 
          v-model="selectedTags" 
          labelValue="name" 
          keyValue="id" 
          @change="onTagsChange"
          />
      </div>
    </div>
    <div class="content-box">
      <div class="content-list flex flex-wrap align-center">
        <div
          class="content-item"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <!-- <div class="image-container" :style="{ backgroundImage: `url(${getLowQualityImage(item.image)})` }"> -->
            <!-- 实际的高清图片 -->
            <!-- <img
              class="image"
              :src="item.image|default_img(false)"
              @error="handleImageError($event, item.image)"
              @load="handleImageLoad($event, item.image)"
              :data-low-quality="getLowQualityImage(item.image)"
              :data-high-quality="item.image"
              loading="lazy"
            />
          </div> -->
          <div 
            class="image-box" 
            :style="{ backgroundImage: `url(${getLowQualityImage(item.image)})` }"
          ></div>
          <!-- <img
              class="image"
              :src="item.image|default_img(false)"
              @error="handleImageError($event, item.image)"
              @load="handleImageLoad($event, item.image)"
              loading="lazy"
            /> -->
          <!-- <img class="image" :src="item.image|default_img"
            @error="handleImageError($event, item.image)"
            @load="handleImageLoad($event, item.image)"
            :data-low-quality="getLowQualityImage(item.image)"
            :data-high-quality="item.image"
            loading="lazy" /> -->
          <div class="fabric-name" :title="type == 'fabric' ? (item.fabric_name_cn || item.goods_no) : item.accessory_name">
            {{ type == "fabric" ? (item.fabric_name_cn || item.goods_no) : item.accessory_name }}
          </div>
          <div class="fabric-code" v-if="type == 'fabric'" :title="item.component">
            成份：{{ item.component }}
          </div>
          <div class="fabric-code" v-else>
            辅料编号：{{ item.accessory_sku }}
          </div>
          <div class="fabric-price" v-if="item.fabric_price>0">¥{{ item.fabric_price }}起</div>
          <div class="fabric-price" v-else>市价</div>
        </div>
      </div>
      <div class="page-container">
        <Page
          :total="total_count"
          :current="Number(query.page)"
          prev-text="上一页"
          next-text="下一页"                                                            
          @on-change="onPageChange"
          :page-size="query.size"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import {
  AccessoryCategoryList,
  AccessoryLabelList,
  AccessoryList,
  FabricCategoryList,
  FabricLabelList,
  FabricList,
} from "@/api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import FloatSelect from "@/components/FloatSelect.vue";
import CollapseText from "@/components/CollapseText.vue";
import TagsList from "@/components/TagsList.vue";

export default {
  data() {
    return {
      list: [],
      category_list: [],
      type: "fabric",
      category_id: 0,
      category_name: '全部',
      label_list: [],
      query: {
        label_id: [],
        keyword: "",
        page: 1,
        size: 35,
        type: 1,
      },
      total_count: 0,
      publish_time_list: [
        { name: "3个月", value: "3" },
        { name: "6个月", value: "6" },
        { name: "9个月", value: "9" },
        { name: "1年", value: "12" },
        { name: "1年以上", value: "12+" },
      ],
      publish_time_selected: [],
      is_from_detail:false,
      higherQuery: {}, // 高级筛选
      selectedTags: [], // 总筛选结果
      selectedTagsObj: {}, // 总筛选结果对象
    };
  },
  components: {
    swiper,
    swiperSlide,
    FloatSelect,
    CollapseText,
    TagsList,
  },
  filters: {},
  watch:{
    'higherQuery': {
      handler(val) { 
        console.log('higherQuery changed', val);
      
        // 1. 先处理高级筛选部分的标签
        const higherTagsMap = {};
        const labelIds = [];
        for (const key in val) {
          if (val[key] && val[key].length > 0) {
            higherTagsMap[key] = val[key].map(v => { 
              labelIds.push(v.id);
              return { name: v.name, id: v.id }
            });
          }
        }
        this.query.label_id = labelIds;
        // 2. 【关键修复】合并其他维度的标签（分类、类型、上市）
        // 我们不能只依赖 higherQuery，必须从当前的 data 中读取最新状态
        
        // 获取分类标签
        higherTagsMap['分类'] = [{ name: this.category_name, id: this.category_id }];

        // 获取类型标签 (仅面料)
        if (this.type === 'fabric') {
          const typeName = this.query.type === 1 ? "面料" : "里料";
          higherTagsMap['类型'] = [{ name: typeName, id: this.query.type }];
        }

        // 获取上市时间标签
        if (this.publish_time_selected.length > 0) {
          higherTagsMap['上市'] = this.publish_time_selected.map(val => {
            const timeItem = this.publish_time_list.find(p => p.value === val);
            return timeItem ? { name: timeItem.name, id: val } : null;
          }).filter(item => item !== null);
        }

        // 3. 统一更新 selectedTagsObj 和 selectedTags
        
        this.selectedTagsObj = { ...higherTagsMap };
        
        // 扁平化为数组
        const list = [];
        for (const key in this.selectedTagsObj) {
          if (this.selectedTagsObj[key] && this.selectedTagsObj[key].length) {
            list.push(...this.selectedTagsObj[key]);
          }
        }
        this.selectedTags = list;

        // 4. 触发搜索
        this.query.page = 1;
        this.onFabricList();
      },
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "light");
    });
  },
  mounted() {
    const from_detail = localStorage.getItem('from_detail');
    if(from_detail){
      this.is_from_detail = from_detail;
    }
    const page = localStorage.getItem('fabricHallPage');
    if(page){
      this.query.page = page;
    }
    const { keyword, category_id, category_name, type } = this.$route.params;
    console.log('this.$route.params:', this.$route.params);
    if(!type){
      const localParams = localStorage.getItem('localParams');
      if(localParams){
        const params = JSON.parse(localParams);
        this.query.keyword = params.keyword || '';
        this.category_id = params.category_id || 0;
        this.category_name = params.category_name || '全部';
        this.type = params.type || 'fabric';
      }
    }else{
      if (keyword) {
        this.query.keyword = keyword;
      }
      console.log(this.$route.params);
      this.category_id = category_id || 0;
      this.category_name = category_name || '全部';
      this.type = type;
      localStorage.setItem('localParams',JSON.stringify({keyword,category_id,category_name,type}))
    }
    this.onFabricLabelList();
    this.onFabricCategoryList();
    this.onFabricList();
    this.syncTagsFromData();
  },
  beforeDestroy() {},
  methods: {
    getLowQualityImage(imageUrl) {
      if (!imageUrl) return this.$options.filters.default_img('', false);
      // return imageUrl;

      // 使用OSS图片处理服务生成低质量版本
      // 这里使用缩放和质量参数来生成低质量版本
      // return `${imageUrl}?x-oss-process=image/resize,w_50,h_50/quality,q_20`;
      // return `${imageUrl}?x-oss-process=image/crop,g_center,w_200,h_200/quality,q_100`;
      // return `${imageUrl}?x-oss-process=image/resize,m_lfit,w_2000/quality,q_100/crop,g_center,w_500,h_500`;
      // return `${imageUrl}?x-oss-process=image/crop,w_200,h_200/format,webp`;
      // return `${imageUrl}?x-oss-process=image/crop,g_center,w_500,h_500/quality,q_80/format,webp`;
      return `${imageUrl}?x-oss-process=image/resize,m_lfit,w_500,h_500/quality,q_80/format,webp`;
    },
    handleImageError(event, originalSrc) {
      // 图片加载失败时，使用默认图片
      event.target.src = this.$options.filters.default_img(originalSrc, false);
    },
    handleImageLoad(event, originalSrc) {
      // 图片加载成功时的处理（可选）
      // 这里可以添加加载完成的逻辑，如移除loading状态
      event.target.classList.add('loaded');
    },
    choose_type(type){
      this.query.type = type;
      this.syncTagsFromData();
      this.onFabricList();
    },
    async onFabricList() {
      this.list = [];
      var param = {
        ...this.query,
      };
      if (this.publish_time_selected.length > 0) {
        param.publish_range = this.publish_time_selected;
      }
      let res;
      if (this.type == "fabric") {
        param.fabric_category_id = this.category_id;
        res = await FabricList(param);
      } else {
        param.accessory_category_id = this.category_id;
        res = await AccessoryList(param);
      }
      const {data} = res;
      this.list = data.list;
      this.total_count = data.total;
      console.log('list',this.list);
      // if(!this.is_from_detail){
      //   this.$nextTick(()=>{
      //     window.scrollTo({
      //       top: 300,
      //       behavior: 'auto'
      //     });
      //   })
      //   console.log('滚动完成');
      // }
      if(localStorage.getItem('fabricHallPage')){
        localStorage.removeItem('fabricHallPage');
      }
      if(localStorage.getItem('from_detail')){
        localStorage.removeItem('from_detail');
      }
    },
    async onFabricLabelList() {
      let res;
      if (this.type == "fabric") {
        res = await FabricLabelList();
      } else {
        res = await AccessoryLabelList();
      }
      const {data} = res;
      this.label_list = data;
    },
    async onFabricCategoryList() {
      let res;
      if (this.type == "fabric") {
        res = await FabricCategoryList();
      } else {
        res = await AccessoryCategoryList();
      }
      const {data} = res;
      this.category_list = data;
    },
    // 选择分类
    choose_category(category_id, category_name) {
      this.category_id = category_id;
      this.query.page = 1;
      this.is_from_detail = false;
      this.category_name = category_name;
      this.syncTagsFromData();
      this.onFabricList();
    },
    // 选择发布时间
    choose_publish_time(data) {
      if (this.publish_time_selected.includes(data.value)) {
        this.publish_time_selected = this.publish_time_selected.filter(
          (item) => {
            return item !== data.value;
          }
        );
      } else {
        this.publish_time_selected.push(data.value);
      }
      this.query.page = 1;
      this.syncTagsFromData();
      this.onFabricList();
    },
    choose_label(v) {
      if (this.query.label_id.includes(v.id)) {
        this.query.label_id = this.query.label_id.filter((item) => {
          return item !== v.id;
        });
      } else {
        this.query.label_id.push(v.id);
        this.query.label_id = [...new Set(this.query.label_id)];
      }
      this.query.page = 1;
      this.onFabricList();
    },

    onSearch() {
      this.query.page = 1;
      this.is_from_detail = false;
      this.onFabricList();
    },
    onPageChange(e) {
      console.log("page_change", e);
      this.is_from_detail = false;
      this.query.page = e;
      this.onFabricList();
    },
    goDetail(item) {
      localStorage.setItem('from_detail',true);
      localStorage.setItem('fabricHallPage',this.query.page);
      // this.$router.push({
      //   name: "FabricHallDetail",
      //   query: { id: item.id, type: this.type },
      // });
      let route = this.$router.resolve({ name: "FabricHallDetail", query: { id: item.id, type: this.type }, })
      window.open(route.href, '_blank')
    },
    // 初始化查询参数
    initQuery() {
      this.query = {
        page: 1,
        size: 35,
        type: 1,
        label_id: [],
        keyword: '',
      };
      this.category_id = 0;
      this.category_name = '全部';
      this.publish_time_selected = [];
      this.higherQuery = {};
    },
    // 筛选结果删减时
    onTagsChange(val) {
      // 根据不同类型的标签进行过滤并对条件赋值然后查询
      console.log('onTagsChange-val:', val);
      const remainingIds = val.map(item => item.id);
      const catTag = val.find(t => t.name === this.category_name || (t.id === this.category_id && this.category_id !== 0));
      // 如果 remainingIds 里没有当前的 category_id，则重置
      if (this.category_id !== 0 && !remainingIds.includes(this.category_id)) {
        this.category_id = 0;
        this.category_name = '全部';
      }
      if (this.type === 'fabric') {
        const currentTypeId = this.query.type;
        if (!remainingIds.includes(currentTypeId)) {
          this.query.type = 1; // 重置为默认
        }
      }
      this.publish_time_selected = this.publish_time_selected.filter(id => remainingIds.includes(id));

      const newHigherQuery = {};
      for (const key in this.higherQuery) {
        const keptItems = this.higherQuery[key].filter(item => remainingIds.includes(item.id));
        if (keptItems.length > 0) {
          newHigherQuery[key] = keptItems;
        }
      }
      this.higherQuery = newHigherQuery; // 这会触发 watch

      const otherIds = remainingIds.filter(id => 
        id !== this.category_id && 
        id !== this.query.type && 
        !this.publish_time_selected.includes(id)
      );
      this.query.page = 1;
      this.syncTagsFromData();
      this.onFabricList();
    },
    // 统一同步方法：根据当前所有 data 状态，重建 selectedTags
    syncTagsFromData() {
      const tagsMap = {};

      // 1. 分类
      if (this.category_id !== 0) {
      }
      tagsMap['分类'] = [{ name: this.category_name, id: this.category_id }];

      // 2. 类型
      if (this.type === 'fabric') {
        tagsMap['类型'] = [{ name: this.query.type === 1 ? "面料" : "里料", id: this.query.type }];
      }

      // 3. 上市
      if (this.publish_time_selected.length > 0) {
        tagsMap['上市'] = this.publish_time_selected.map(val => {
          const timeItem = this.publish_time_list.find(p => p.value === val);
          return timeItem ? { name: timeItem.name, id: val } : null;
        }).filter(item => item !== null);
      }

      // 4. 高级筛选
      for (const key in this.higherQuery) {
        if (this.higherQuery[key] && this.higherQuery[key].length > 0) {
          tagsMap[key] = this.higherQuery[key].map(v => ({ name: v.name, id: v.id }));
        }
      }

      this.selectedTagsObj = tagsMap;

      const list = [];
      for (const key in this.selectedTagsObj) {
        if (this.selectedTagsObj[key]) {
          list.push(...this.selectedTagsObj[key]);
        }
      }
      this.selectedTags = list;
    },
  },
};
</script>
<style lang="scss" scoped>
.container{
  width:100%;
  min-height:100%;
  background-color: #F8F9FB;
  .banner {
    width: 100%;
    background-image: url(../../assets/images/fabricHall/banner.png);
    height: 350px;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .text-filter {
      width: 900px;
      height: 56px;
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid #d8d7d9;
      margin-left: 60px;
      margin-bottom: 60px;
      .search-input {
        flex: 1;
        border: none !important;
        background: transparent;
        height: 100%;
        padding-left: 25px;
        padding-right: 5px;
        outline: none !important;
      }
      .search-submit {
        width: 120px;
        height: 46px;
        background: #ff5967;
        border-radius: 5px;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
        margin-right: 5px;
        border: none;
      }
    }
  }
  .bread-nav-box {
    padding: 30px 100px 10px 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .bread-nav {
      display: flex;
      align-items: center;
      .stick {
        display: inline-block;
        width: 4px;
        height: 28px;
        background: #FF5967;
        border-radius: 2px 2px 2px 2px;
      }
      .bread-nav-title {
        font-weight: bold;
        font-size: 22px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 12px;
        margin-right: 11px;
      }
      .bread-nav-info {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
    .text-filter {
      width: 637px;
      height: 56px;
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid #d8d7d9;
      .search-input {
        flex: 1;
        border: none !important;
        background: transparent;
        height: 100%;
        padding-left: 25px;
        padding-right: 5px;
        outline: none !important;
      }
      .search-submit {
        width: 120px;
        height: 46px;
        background: #ff5967;
        border-radius: 5px;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
        margin-right: 5px;
        border: none;
      }
    }
  }
  .category-list {
    padding: 10px 100px;
    margin: 0 auto;
    .label-box {
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #e0e0e0;
      padding: 12px 16px;
      .label-list {
        padding: 10px 0;
        .label-title {
          color: #333333;
          line-height: 21px;
          text-align: left;
          white-space:nowrap;
          text-overflow: ellipsis;
          overflow:hidden;
          width:fit-content;
          flex-shrink:0;
          font-size: 14px;
        }
        .label-items {
          display: flex;
          flex-wrap: wrap;
          gap: 12px 0;
          color: #333333;
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          // margin-bottom: 5px;
          .label-item {
            padding: 0 15px;
            // height: 20px;
            // line-height: 20px;
            cursor: pointer;
            transition: all 0.2s;
            &.active {
              color: #fa3d5a;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .filter-result-box {
    padding: 6px 100px 10px 100px;
    .filter-result { 
      padding: 10px 16px;
      background: #ffffff;
    }
  }
  .content-box {
    padding: 0px 100px 30px 100px;
    background: #f8f9fb;

    .content-list {
      // margin-top: 36px;
      display:flex;
      gap:20px;
      .content-item {
        // width: 220px;
        width:calc(100% / 7 - 17.5px);
        height: 320px;
        background: #ffffff;
        // margin-right: 20px;
        // margin-bottom: 20px;
        padding: 10px;
        cursor:pointer;
        display:flex;
        flex-direction:column;
        align-items:center;
        &:hover{
          box-shadow: 0px 0px 7px 0px #D4D4D4;
        }
        // .image {
        //   width: 200px;
        //   height: 208px;
        // }
        
        .image {
          // width: 200px;
          width:100%;
          height: 208px;
          object-fit:contain;
        }

        .image-box {
          width: 100%;
          aspect-ratio: 1 / 1; 
          
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #ffffff;
          
          transform: translateZ(0);
          backface-visibility: hidden;
          
          transition: transform 0.3s ease;
          
        }

        // .image-container {
        //   position: relative;
        //   // width: 200px;
        //   width:100%;
        //   height: 208px;
        //   background-size: cover;
        //   background-position: center;

        //   .image {
        //     width: 100%;
        //     height: 100%;
        //     object-fit: cover;
        //     opacity: 0;
        //     transition: opacity 0.3s ease-in-out;

        //     &.loaded {
        //       opacity: 1;
        //     }
        //   }
        // }
        .fabric-name {
          font-size: 16px;
          line-height: 24px;
          color: #1a1a1a;
          margin-top: 8px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          text-align:left;
          width:100%;
        }
        .fabric-code {
          font-size: 14px;
          line-height: 21px;
          color: #808080;
          margin-top: 2px;
          text-align:left;
          width:100%;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
        }
        .fabric-price {
          font-size: 16px;
          line-height: 24px;
          color: #e00000;
          margin-top: 6px;
          text-align:left;
          width:100%;
        }
      }
    }

    .page-container{
      margin-top:91px;
    }
    .show-more {
      margin: 80px auto;
      width: 200px;
      height: 56px;
      line-height: 56px;
      background: #f8f6f9;
      border-radius: 28px 28px 28px 28px;
      border: 1px solid #cccccc;
      text-align: center;
      cursor: pointer;
    }
  }
  .creator-box {
    background: #ffffff;
    border-radius: 15px;
    font-size: 16px;
    text-align: center;
    margin: 10px 5px;
    .item-box {
      .menu-item {
        height: 45px;
        line-height: 45px;
        color: #000000;
        cursor: pointer;
        text-align: center;

        &:hover {
          border-radius: 10px;
          background: #ff5967;
          color: #ffffff;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .container {
    transform: scale(0.95); // 缩小到原来的95%
    transform-origin: top left; // 设置缩放原点为左上角
    width: calc(100vw / 0.95); //宽度补齐
    height:calc(100vh / 0.95);
  }
}

@media screen and (max-width: 1279px) {
  .container {
    transform: scale(0.85); // 缩小到原来的85%
    transform-origin: top left; // 设置缩放原点为左上角
    width:calc(100% / 0.85); //宽度补齐
    height:calc(100vh / 0.95);
  }
}
</style>
